<template>
  <div style="height: 100%">
    <v-container fluid v-if="loading" style="height: 100%">
      <v-layout align-center justify-center row fill-height class="text-xs-center" style="height: 100%">
        <v-progress-circular
            :size="50"
            :color="app.color_name"
            indeterminate
            class="ma-5"
        ></v-progress-circular>
      </v-layout>
    </v-container>

    <v-container whole-width fluid grid-list-xl v-if="!loading && stats.total.onboardingStep < 6">
      <v-layout row>
        <v-flex lg12 xl12>
          <v-layout row wrap>
            <v-flex xs12 lg7>
              <h1 class="main-title mb-3">Getting started with your first loyalty campaign</h1>

              <v-stepper v-model="stats.total.onboardingStep" vertical>
                <v-stepper-step :complete="stats.total.onboardingStep > 1" step="1" :color="app.color_name">Create a
                  brand
                </v-stepper-step>

                <v-stepper-content step="1">
                  <v-icon :color="app.color_name" size="64" class="mb-2">brand</v-icon>
                  <p class="subheading">A brand is an entity to which you can link staff members and loyalty campaigns.
                    Let's start by setting up a brand.</p>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="app.color_name" text :to="{name: 'user.businesses'}">Create a brand
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-stepper-content>

                <v-stepper-step :complete="stats.total.onboardingStep > 2" step="2" :color="app.color_name">Create a
                  staff member
                </v-stepper-step>

                <v-stepper-content step="2">
                  <v-icon :color="app.color_name" size="64" class="mb-2">supervised_user_circle</v-icon>
                  <p class="subheading">A staff member can give customers loyalty points and redeem rewards. Staff
                    members belong to one or more brands.</p>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="app.color_name" text :to="{name: 'user.staff'}">Create a staff member
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-stepper-content>

                <v-stepper-step :complete="stats.total.onboardingStep > 3" step="3" :color="app.color_name">Create a
                  reward
                </v-stepper-step>

                <v-stepper-content step="3">
                  <v-icon :color="app.color_name" size="64" class="mb-2">fas fa-gift</v-icon>
                  <p class="subheading">Customers can exchange their points for rewards. A campaign can have one or more
                    rewards.</p>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="app.color_name" text :to="{name: 'user.rewards'}">Create a reward
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-stepper-content>

                <v-stepper-step :complete="stats.total.onboardingStep > 4" step="4" :color="app.color_name">Create a
                  loyalty campaign
                </v-stepper-step>

                <v-stepper-content step="4">
                  <v-icon :color="app.color_name" size="64" class="mb-2">record_voice_over</v-icon>
                  <p class="subheading">A campaign is a website where customers can sign up, earn points and redeem
                    rewards.</p>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="app.color_name" text :to="{name: 'user.campaigns'}">Create a campaign
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-stepper-content>

                <v-stepper-step step="5" :color="app.color_name">Onboard your first customer</v-stepper-step>

                <v-stepper-content step="5">
                  <v-icon :color="app.color_name" size="64" class="mb-2">contacts</v-icon>
                  <p class="subheading">Promote your campaign and grow your customer base!</p>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="app.color_name" text :to="{name: 'user.customers'}">View customers
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-stepper-content>
              </v-stepper>

            </v-flex>

          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container class="stats-dash" style="background-color:#fff; border-top: solid 1px #edf1f6" whole-width fluid
                 grid-list-xl v-if="!loading && stats.total.onboardingStep >= 6">
      <v-layout row> <!-- ROW 1 START -->
        <v-flex lg12 xl12>
          <v-layout row wrap>
            <v-flex md12 mr-1>
              <v-flex xs12>

                <h2 class="main-title mb-3">Dashboard</h2>

                <h3 class="top-section-header text-dark mb-3 mr-3 md1 fl">Filters</h3>

                <div class="mb1 fl br-1" style="max-width: 100px;">
                  <v-combobox
                      :items="programs"
                      v-model="program"
                      item-value="uuid"
                      item-text="name"
                      label="Programs"
                      data-vv-name="programs"
                      :error-messages="errors.collect('')"
                      @change="(changePrograms($event))"
                  ></v-combobox>
                </div>
                <div class="mb1 fl" style="max-width: 100px;">
                  <v-combobox
                      :items="brands"
                      v-model="brand"
                      item-value="uuid"
                      item-text="name"
                      label="Brands"
                      :error-messages="errors.collect('')"
                      @change="(changeBrands($event))"
                  ></v-combobox>
                </div>
                <div class="mb1 fl" style="max-width: 100px;">
                  <v-combobox
                      :items="countries"
                      v-model="country"
                      item-value="name"
                      item-text="name"
                      label="Countries"
                      :error-messages="errors.collect('')"
                      @change="(changeCountries($event))"
                  ></v-combobox>
                </div>
                <div class="mb1 fl" style="max-width: 100px;">
                  <v-combobox
                      :items="regions"
                      v-model="region"
                      item-value="name"
                      item-text="name"
                      label="Regions"
                      data-vv-name="Regions"
                      :error-messages="errors.collect('')"
                      @change="(changeRegions($event))"
                  ></v-combobox>
                </div>
                <div class="mb1 fl" style="max-width: 100px;">
                  <v-combobox
                      :items="cities"
                      v-model="city"
                      item-value="name"
                      item-text="name"
                      label="Cities"
                      data-vv-name="Cities"
                      @change="(changeCities($event))"
                      :error-messages="errors.collect('')"
                  ></v-combobox>
                </div>
                <div class="mb1 fl" style="max-width: 100px;">
                  <v-combobox
                      :items="stores"
                      v-model="store"
                      item-value="id"
                      item-text="desc"
                      label="Stores"
                      data-vv-name="stores"
                      @change="(changeStores($event))"
                      :error-messages="errors.collect('')"
                  ></v-combobox>
                </div>

                <div class="mb1 fl">
                  <!--                  <h3 class="top-section-header text-dark mb-3 fl">Date Range</h3>-->
                  <datepicker
                      range
                      v-model="range"
                      circle
                      :lang="'en'"
                      showClearButton
                      @input="getData"
                      @reset="clearDates"
                  >
                  </datepicker>
                </div>

                <div class="ml-3 mt-2 fl">
                  <b-button @click="clearFilters" variant="outline-primary">Clear Filters</b-button>
                </div>

              </v-flex>
            </v-flex>

          </v-layout>

        </v-flex>

      </v-layout> <!-- ROW 1 END -->


      <v-layout row> <!-- ROW 2 START -->
        <v-flex lg8 xl8>
          <v-layout row wrap>

            <v-flex xs1half>
              <div class="card report-card">
                <div class="card-body">

                  <h3 v-if="!loadingComponents" class="my-3">{{ formatNumber(customersTotal) }}</h3>
                  <h3 v-if="loadingComponents" class="my-3">
                    <b-spinner v-if="loadingComponents" variant="primary" label="Spinning"></b-spinner>
                  </h3>

                  <h2 class="top-section-header my-2">TOTAL CUSTOMERS</h2>
                </div>
              </div>
            </v-flex>

            <v-flex xs1half>
              <div class="card report-card">
                <div class="card-body">
                  <h3 v-if="!loadingComponents" class="my-3">{{ formatNumber(brands.length) }}</h3>
                  <h3 v-if="loadingComponents" class="my-3">
                    <b-spinner v-if="loadingComponents" variant="primary" label="Spinning"></b-spinner>
                  </h3>

                  <h2 class="top-section-header my-2">BRANDS</h2>
                </div>
              </div>
            </v-flex>

            <v-flex xs1half>
              <div class="card report-card">
                <div class="card-body">
                  <h3 v-if="!loadingComponents" class="my-3">{{ formatNumber(stores.length) }}</h3>
                  <h3 v-if="loadingComponents" class="my-3">
                    <b-spinner v-if="loadingComponents" variant="primary" label="Spinning"></b-spinner>
                  </h3>

                  <h2 class="top-section-header my-2">STORES</h2>
                </div>
              </div>
            </v-flex>

            <v-flex xs1half>
              <div class="card report-card">
                <div class="card-body">
                  <h3 v-if="!loadingComponents" class="my-3">{{ formatNumber(websites.length) }}</h3>
                  <h3 v-if="loadingComponents" class="my-3">
                    <b-spinner v-if="loadingComponents" variant="primary" label="Spinning"></b-spinner>
                  </h3>

                  <h2 class="top-section-header my-2">WEBSITES</h2>
                </div>
              </div>
            </v-flex>

          </v-layout>
        </v-flex>

      </v-layout><!-- ROW 2 END -->

      <v-row row> <!-- ROW 3 START -->
        <v-col cols="8">
            <apexchart style="overflow: auto;"
                ref="pointsChart"
                type="area"
                :noData="noData"
                :options="chartOptionsPoints"
                :series="pointsChartData"></apexchart>
        </v-col>
          <v-col cols="4">
                  <h3 class="top-section-header text-dark mb-3 ml-10 fl">Customers</h3>
                  <apexchart ref="realtimeChart" :options="customersChartOptions" :noData="noData" :series="customersChartData"></apexchart>
          </v-col>
      </v-row><!-- ROW 3 END -->

    </v-container>
  </div>
</template>


<script>
export default {
  $_veeValidate: {
    validator: 'new'
  },
  mounted() {
    let locale = Intl.DateTimeFormat().resolvedOptions().locale || 'en'
    locale = (this.$auth.check()) ? this.$auth.user().locale : locale
    this.locale = locale

    moment.locale(this.locale.substr(0, 2))

    this.onResize()
    window.addEventListener('resize', this.onResize, {passive: true})

  },
  data() {
    return {
      dateFilter: false,
      program: null,
      brand: null,
      country: null,
      countryName:'',
      region: null,
      regionName:'',
      city: null,
      cityName:'',
      store: null,
      range: {
        start: '',
        end: '',
      },
      locale: 'en',
      loading: true,
      loadingComponents: false,

      //Filters
      programID: '',
      brandID: '',
      countrieID: '',
      regionID: '',
      cityID: '',
      storeID: '',
      programGUID: null,

      //Objects
      programs: [],
      brands: [],
      countries: [],
      regions: [],
      cities: [],
      stores: [],
      websites: [],
      customersChartOptions: {
        noData: {
          text: "Loading...",
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: "#008FFB",
            fontSize: '16px',
            // fontFamily: "Helvetica"
          }
        },
        labels: ['Active', 'Inactive', 'New'],
        chart: {
          type: 'donut',
        },
        plotOptions: {
          pie: {
            customScale: 1,
            donut: {
              size: '75%',
            },
            // offsetY: 20,
          },
          stroke: {
            colors: undefined
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 100
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      customers: [],
      customersChartData: [0,0,0],
      customersTotal: 0,
      points: [],


      stats: null,
      statTabs: 'points',
      topTabs: 'brands',

      pointsChartData: [],

      pointChartData: [],
      customerChartDataCategory: [],
      earningChartData: [],
      spendingChartData: [],


      staff: [],
      showRegistration: true,
      showRedeem: false,
      showEarned: false,
      showRevenue: false,
      loadingBusiness: false,
      loadingLocation: false,
      loadingWebsites: false,

      order: '',
      customerDataOption: 'customers_earned',
      staffDataOption: 'staff_registration',
      chartOptionsPoints: {
        noData: {
          text: 'Loading...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#008FFB',
            fontSize: '16px',
            // fontFamily: "Helvetica"
          }
        },
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          },
          type: 'area',
          stacked: true,
          events: {
            selection: function (chart, e) {
              console.log(new Date(e.xaxis.min))
            }
          },
        },
        colors: ['#008FFB', '#00E396', '#CED4DC'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        },
        xaxis: {
          type: 'datetime'
        }

      }
    }
  },
  created() {
    this.getData();
  },
  methods: {
    changePrograms(event) {

      if((this.range[0]==null && this.range[1]!=null) || (this.range[0]!=null && this.range[1]==null))
      {
        that.loading = false;
        return;
      }
      if(this.range[0]!=null && this.range[1]!=null)
      {
        this.dateFilter = true;
      }

      this.programGUID = event.uuid


      this.brands = [];
      this.stores = [];
      this.loadingComponents = true;
      this.pointsChartData = [];
      this.customersChartData = [0,0,0];
      //clear  fields
      this.brand = null;
      this.country = null
      this.region = null
      this.city = null
      this.store = null

      if (event != '') {

        this.getDataByProgram(this.programGUID, this.dateFilter,this.range);

      } else {
        axios
            .get('/user/business/orderByBusiness')
            .then(response => {

              this.brands = response.data.businesses;

            });

        axios
            .get('/user/location/orderByLocation')
            .then(response => {
              this.stores = response.data.locations;
            });

      }
    },
    changeBrands(event) {

      let brandID = event.id
      this.country = null
      this.region = null
      this.city = null
      this.store = null

      this.loadingComponents = true;
      this.pointsChartData = [];
      this.customersChartData = [0,0,0];

      //GET Countries
      axios
          .get('/countriesbybusiness/' + brandID)
          .then(response => {
            if (response.data.country.length > 0) {
              this.countries = response.data.country;
            } else {
              this.countries = [];
            }
          })

      //GET Stores
      axios
          .get('/locationbybusiness/' + brandID)
          .then(response => {
            let stores = response.data.places;
            this.stores = stores.map(store => {
              return {id: store.pk, desc: store.desc};
            });

          });
      //GET Customers
      axios
          .get('/customersbybrand/' + brandID)
          .then(response => {
            let customers = response.data.customers;

              let active = 0;
              let inactive = 0;
              let recent = 0;

              customers.map(customer => {

                if (customer.active == 1) {
                  active = active + 1;
                } else {
                  inactive = inactive + 1;
                }

              });

              this.customersChartData = [active, inactive, recent];

              this.customersTotal = active + inactive + recent;
              this.loadingComponents = false;

          });

      //GET WEBSITES
      axios
          .get('/websitesbybrandid/' + brandID)
          .then(response => {
            this.websites = response.data.websites;
          });

      //Get Points
      axios
          .get('/pointsbybrandid/' + brandID)
          .then(response => {

            this.fillPointsChart(response, this.dateFilter, this.range)

          })

    },
    changeCountries(event) {

      
      this.countryName = event.name
      this.regions = [];
      this.region = null
      this.city = null
      this.store = null

      this.loadingComponents = true;

      if (event != '') {
        axios
            .get('/regionsbycountry/' + this.countryName)
            .then(response => {

              this.regions = response.data.places;
              this.loadingComponents = false;

            });
      }
    },
    changeRegions(event) {

      this.regionName = event.name

      this.cities = [];
      this.city = null
      this.store = null
      this.loadingComponents = true;


      if (event != '') {
        axios
            .get('/citiesbyregion/' + this.countryName + '/' + this.regionName)
            .then(response => {
              this.cities = response.data.places;
              this.loadingComponents = false;
            });
      }
    },
    changeCities(event) {

      this.cityName = event.name
      this.store = null
      this.loadingComponents = true;


      if (event != '') {
        axios
            .get('/locationsbycity/' + this.cityName)
            .then(response => {
              let stores = response.data.stores;

              this.stores = stores.map(store => {
                return {id: store.pk, desc: store.desc};
              });
              this.loadingComponents = false;

            });
      }
    },
    changeStores(event) {

      let locationID = event.id
      this.loadingComponents = true;
      this.pointsChartData = [];
      this.customersChartData = [0,0,0];


      if (event != '') {
        axios
            .get('/customersbylocationid/' + locationID)
            .then(response => {
              let customers = response.data.customers;

              let active = 0;
              let inactive = 0;
              let recent = 0;

              customers.map(customer => {

                if (customer.active == 1) {
                  active = active + 1;
                } else {
                  inactive = inactive + 1;
                }

              });

              this.customersChartData = [active, inactive, recent];

              this.customersTotal = active + inactive + recent;
              this.loadingComponents = false;

            });
        //Get Points
        axios
            .get('/pointsbylocationid/' + locationID)
            .then(response => {

              this.fillPointsChart(response, this.dateFilter, this.range)
              this.loadingComponents = false;

            })
      }
    },
    orderLocation(event, column) {
      if (this.order == 'asc') {
        this.order = 'desc';
      } else {
        this.order = 'asc';
      }

      this.locations = _.orderBy(this.locations, column, this.order);
    },
    orderBusiness(column) {
      /*this.loadingBusiness = true;
      axios.get('/user/business/orderByBusiness', {
                params:
                        {
                          column: column
                        }
              }
      )
      .then(response => {
        this.businesses = response.data.businesses;
        this.loadingBusiness = false;
      });*/
      if (this.order == 'asc') {
        this.order = 'desc';
      } else {
        this.order = 'asc';
      }

      this.businesses = _.orderBy(this.businesses, column, this.order);
    },
    formatNumber(number) {
      // return number > 9999 ? Math.floor(number/1000) + 'K' : number;
      // return new Intl.NumberFormat(this.locale.replace('_', '-')).format(number)
      return Math.floor(number);
    },
    onResize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':

          break;
        case 'sm':

          break;
        default:

          break;
      }
    },
    getXcoordenate(periodUnit, date) {
      let xCoordanate = moment(date).format("DD MMMM");

      switch (periodUnit) {
        case 'days':
          xCoordanate = moment(date).format("DD MMMM");
          break;
        case 'weeks':
          xCoordanate = moment().week(date).subtract(1, "week").format("DD") + '-' + moment().week(date).format("DD MMMM");
          break;
        case 'months':
          xCoordanate = moment(date).format("MMMM");
          break;
      }

      return xCoordanate;
    },
    refreshCustomerData() {

    },
    changeStaffGraphic(event, column) {
      this.showRegistration = false;
      this.showRedeem = false;
      this.showEarned = false;
      this.showRevenue = false;

      this.staffDataOption = column;

      switch (column) {
        case 'staff_registration':
          this.showRegistration = true;
          break;
        case 'staff_redeem':
          this.showRedeem = true;
          break;
        case 'staff_earned':
          this.showEarned = true;
          break;
        case 'staff_revenue':
          this.showRevenue = true;
          break;
      }

      return true;

    },
    changeCustomerGraphic(event, column) {
      /*this.customerChartData[0].data = [];*/
      this.customerDataOption = column;
      this.loading = true;
      let newData = [];

      _.map(this.stats.customers[column], (count, date) => {
        newData.push({
          y: count,
          x: moment(date).format("DD MMMM")
        });
      });

      this.$refs.realtimeChart.updateSeries([{
        data: newData
      }], false, true);


      this.loading = false
    },
    clearDates() {
      this.dateFilter = false;
      this.range =[null, null];

      this.getData();
    },
    getDataByProgram(programGUID,dateFilter,range) {
      axios
            .get('/businessbyprogramid/' + programGUID)
            .then(response => {
              let places = response.data.places;

              this.brands = places.map(place => {
                return {id: place.pk, name: place.val};
              });

            });

        axios
            .get('/locationbyprogramid/' + programGUID) // ProgramController@getLocationsByProgramGUID
            .then(response => {
              let stores = response.data.places;

              this.stores = stores.map(store => {
                return {id: store.pk, desc: store.desc};
              });

            });

        axios
            .get('/customersbyprogramid/' + programGUID)
            .then(response => {

              let customers = response.data.customers;

              let active = 0;
              let inactive = 0;
              let recent = 0;

              customers.map(customer => {

                if(dateFilter && (Date.parse(customer.created_at)<range[0] || Date.parse(customer.created_at)>range[1]))
                {
                  //out of date range if any
                  return false;
                }

                if (customer.active == 1) {
                  active = active + 1;
                } else {
                  inactive = inactive + 1;
                }

              });

              this.customersChartData = [active, inactive, recent];

              this.customersTotal = active + inactive + recent;
              this.loadingComponents = false;

            });

        axios
            .get('/websitesbyprogramid/' + programGUID)
            .then(response => {
              this.websites = response.data.websites;
            });

        axios
            .get('/countriesbyprogramid/' + programGUID)
            .then(response => {

              this.countries = response.data.countries;
            });


        axios
            .get('/pointsbyprogram/' + programGUID)
            .then(response => {

              this.fillPointsChart(response, dateFilter, range)
              this.loadingComponents = false;

            })

    },
    getData() {

      if((this.range[0]==null && this.range[1]!=null) || (this.range[0]!=null && this.range[1]==null))
      {
        this.loading = false;
        return;
      }
      if(this.range[0]!=null && this.range[1]!=null)
      {
        this.dateFilter = true;
      }

      console.log("programGUID", this.programGUID);

      if(this.programGUID==null)
      {
        const that = this;
        this.loadingComponents = true;
        this.pointsChartData = [];
        this.customersChartData = [0,0,0];

        axios
            .get('/app/getprograms')
            .then(response => {
              this.programs = response.data.programs;
            });

        axios
            .get('/user/business/orderByBusiness')
            .then(response => {
              this.brands = response.data.businesses;
            });

        axios
            .get('/user/location/orderByLocation')
            .then(response => {
              this.stores = response.data.locations;
            });

        axios
            .get('/user/location/orderByLocation')
            .then(response => {
              this.stores = response.data.locations;
            });


        axios
            .get('/countries')
            .then(response => {
              this.countries = response.data.countries;
            });

        axios
            .get('/app/customersbyuser')
            .then(response => {

                let customers = response.data.customers;

                let active = 0;
                let inactive = 0;
                let recent = 0;

                customers.map(customer => {

                  if(this.dateFilter && (Date.parse(customer.created_at)<this.range[0] || Date.parse(customer.created_at)>this.range[1]))
                  {
                    //out of date range if any
                    return false;
                  }

                  if (customer.active == 1) {
                    active = active + 1;
                  } else {
                    inactive = inactive + 1;
                  }

                });

                this.customersChartData = [active, inactive, recent];

                this.customersTotal = active + inactive + recent;
                this.loadingComponents = false;

            });

        axios
            .get('/user/points')
            .then(response => {

              this.points = response.data.points;

              let awarded = [];
              let redeemed = [];

              this.points.map(point => {

                if(this.dateFilter && (Date.parse(point.created_at)<this.range[0] || Date.parse(point.created_at)>this.range[1]))
                  {
                    //out of date range if any
                    return false;
                  }

                if (point.is_redeem == 1) {
                  redeemed.push([new Date(point.created_at).getTime(), point.points])
                } else {
                  awarded.push([new Date(point.created_at).getTime(), point.points])
                }

              });

              this.pointsChartData = [{
                name: 'Awarded',
                data: awarded
              },
                {
                  name: 'Redeemed',
                  data: redeemed
                }]

            });

        axios
            .get('/user/stats', {
                  params:
                      {
                        locale: this.$i18n.locale,
                        start: this.range[0] || null,
                        end: this.range[1] || null
                      }
                }
            )
            .then(response => {
              let stats = response.data;
              that.stats = stats;
              this.customerChartDataCategory = [];
              this.customerChartData = [{
                name: 'People',
                data: []
              }];

              this.locations = stats.locations;
              this.businesses = stats.businesses;
              this.websites = stats.websites;
              this.staff = stats.staff;

              _.map(stats.customers.customers_earned, (count, date) => {
                this.customerChartData[0].data.push({
                  y: count,
                  x: moment(date).format("DD MMMM")
                });
              });

              // Points
              this.pointChartData = [{
                name: 'Redeemed',
                data: []
              },
                {
                  name: 'Earned',
                  data: []
                },
                {
                  name: 'Expired',
                  data: []
                }];


              _.map(stats.points.points_redeem, (count, date) => {
                this.pointChartData[0].data.push({
                  y: count,
                  x: this.getXcoordenate(stats.points.periodUnit, date)
                });
              });

              _.map(stats.points.points_earned, (count, date) => {
                this.pointChartData[1].data.push({
                  y: count,
                  x: this.getXcoordenate(stats.points.periodUnit, date)
                });
              });

              _.map(stats.points.points_expired, (count, date) => {
                this.pointChartData[2].data.push({
                  y: count,
                  x: this.getXcoordenate(stats.points.periodUnit, date)
                });
              });


              // Revenue
              this.earningChartData = [{
                name: 'Redeemed',
                data: []
              },
                {
                  name: 'Earned',
                  data: []
                }];

              _.map(stats.points.revenue_redeem, (count, date) => {
                this.earningChartData[0].data.push({
                  y: count,
                  x: this.getXcoordenate(stats.points.periodUnit, date)
                });
              });

              _.map(stats.points.revenue_earned, (count, date) => {
                this.earningChartData[1].data.push({
                  y: count,
                  x: this.getXcoordenate(stats.points.periodUnit, date)
                });
              });

              that.loading = false

            })

      }
      else
      {
        this.getDataByProgram(this.programGUID, this.dateFilter, this.range)
      }



    },
    fillPointsChart(response, dateFilter, range) {
      let awarded = [];
      let redeemed = [];

      console.log("fillPointsChart", dateFilter, range);

      _.forEach(response.data.histories, function (point) {

        console.log("point.created_at", point.created_at)
        if(dateFilter && (Date.parse(point.created_at)<range[0] || Date.parse(point.created_at)>range[1]))
        {
          console.log("out");
          //out of date range if any
         return;
        }

        console.log("in");

        if (point.is_redeem == 1) {
          redeemed.push([new Date(point.created_at).getTime(), point.points])
        } else {
          awarded.push([new Date(point.created_at).getTime(), point.points])
        }
      });

      this.pointsChartData = [{
        name: 'Awarded',
        data: awarded
      },
        {
          name: 'Redeemed',
          data: redeemed
        }]
    },
    clearFilters() {
      //clear  fields
      this.program = null;
      this.programGUID = null;
      this.brand = null;
      this.country = null
      this.region = null
      this.city = null
      this.store = null
      this.range =[null, null];
      this.getData();
    }
  }
  ,
  computed: {
    app() {
      return this.$store.getters.app
    }
  }
}
</script>
<style>
</style>
